// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { getIriFromObj } from 'utils/processors';

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values) });

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    id: undefined,
    files: undefined,
    depth: undefined,
    isBeingAdded: undefined,
    isBeingEdited: undefined,
    isBeingDeleted: undefined,
    isBeingReplied: undefined,
    businessOpportunity: 'businessOpportunity' in (values || {}) ? getIriFromObj(values.businessOpportunity) : undefined,
    workOrder: 'workOrder' in (values || {}) ? getIriFromObj(values.workOrder) : undefined,
    task: 'task' in (values || {}) ? getIriFromObj(values.task) : undefined,
    followUpStep: 'followUpStep' in (values || {}) ? getIriFromObj(values.followUpStep) : undefined,
    repliesTo: 'repliesTo' in (values || {}) ? getIriFromObj(values.repliesTo) : undefined,
    replies:
        'replies' in (values || {}) && Array.isArray(values.replies) ? values.replies.map((reply) => processEntityOutput(reply)) : undefined
});

export const findNoteById = (notes, noteId) => {
    if (!noteId) {
        return null;
    }

    const findAndReturnNote = (notes) => {
        for (let i = 0; i < notes.length; i++) {
            const note = notes[i];

            if (note?.id === noteId) {
                return note;
            }
            if (note?.replies?.length > 0) {
                const foundNote = findAndReturnNote(note.replies);
                if (foundNote) {
                    return foundNote;
                }
            }
        }

        return null;
    };

    return findAndReturnNote(notes);
};

export const editNote = (notes, noteId, updNote) => {
    if (!noteId) {
        return null;
    }

    const findAndEditNote = (notes) => {
        const notesCopy = [...notes];
        for (let i = 0; i < notes.length; i++) {
            const note = notes[i];

            if (note?.id === noteId) {
                notesCopy[i] = { ...note, ...updNote };
                break;
            }
            if (note?.replies?.length > 0) {
                notesCopy[i] = { ...note, replies: findAndEditNote(note.replies) };
            }
        }

        return notesCopy;
    };

    return findAndEditNote(notes);
};

export const deleteNote = (notes, noteId) => {
    if (!noteId) {
        return null;
    }

    const notesCopy = [...notes];

    const findAndDeleteNote = (notes) => {
        for (let i = 0; i < notes.length; i++) {
            const note = notes[i];

            if (note?.id === noteId) {
                notes.splice(i, 1);
                break;
            }
            if (note?.replies?.length > 0) {
                findAndDeleteNote(note.replies);
            }
        }

        return notes;
    };

    return findAndDeleteNote(notesCopy);
};

export const insertReplyToNote = (notes, targetNote, replyNote) => {
    if (!targetNote) {
        return null;
    }

    const notesCopy = [...notes];

    const insertReply = (notes) => {
        for (let i = 0; i < notes.length; i++) {
            const note = notes[i];

            if (note?.id === targetNote) {
                notes[i] = {
                    ...note,
                    replies: [...(note?.replies || []), { ...replyNote, repliesTo: targetNote }],
                    isBeingReplied: true
                };
                break;
            } else if (note?.replies?.length > 0) {
                insertReply(note.replies);
            }
        }

        return notes;
    };

    return insertReply(notesCopy);
};
